import { Icon, Table } from "semantic-ui-react";

import type { OpenAPI } from "simplydo/interfaces";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
} from "../Styles";

const CompanyServices = ({
  services = [],
}: {
  services: OpenAPI.Schemas["Company"]["ai"]["services"];
}) => {
  if (services.length) {
    return (
      <InfoBoxWidget>
        <InfoBoxWidgetTitleArea>
          <Icon name="balance scale" />
          <div>
            <h3>Services</h3>
            <span>
              Products and/or services found from analysing the business website
            </span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          <Table definition>
            {services.map((service) => (
              <Table.Row key={service.name}>
                <Table.Cell collapsing>{service.name}</Table.Cell>
                <Table.Cell>{service.description}</Table.Cell>
              </Table.Row>
            ))}
          </Table>
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyServices;
